module.exports = __webpack_public_path__ + "media/images/result_sets/hero-ba5ea0e54f0311a17e829cbc1192d0f8.svg";